<div mat-dialog-content class="teranet-padding">
  <h6>{{data.message}}</h6>
  <div fxLayout="row wrap" fxLayoutAlign="end">
    <button mat-raised-button class="plain-button" (click)="onNoClick()" *ngIf="data.disableClose == null || data.disableClose == undefined">
      No
    </button>
    <button mat-raised-button class="theme-button" [mat-dialog-close]="true" cdkFocusInitial>
      {{ data.confirmButtonText == null || data.confirmButtonText == undefined ? 'Yes' : data.confirmButtonText}}
    </button>
  </div>
</div>
